import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BadgeCheck, Star, Award } from "lucide-react";
import { toast } from "react-toastify";
import API from "../services/api";

const BadgesPage = () => {
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBadges = async () => {
      try {
        const res = await API.get("/dashboard/profile");
        const user = res.data.user;
        setBadges(user.badges || []);
      } catch (err) {
        console.error("Badge fetch error:", err);
        toast.error("Failed to load badges");
      } finally {
        setLoading(false);
      }
    };
    fetchBadges();
  }, []);

  const badgeIcons = {
    "Super Voter": <BadgeCheck className="w-8 h-8 text-green-600" />,
    "Early Raiser": <Star className="w-8 h-8 text-yellow-500" />,
    "Verified Voter": <Award className="w-8 h-8 text-blue-600" />,
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-green-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-xl shadow p-8"
        >
          <h1 className="text-3xl font-bold text-center text-orange-600 mb-6">
            🏅 My Badges
          </h1>

          {loading ? (
            <div className="text-center text-gray-500">Loading badges...</div>
          ) : badges.length === 0 ? (
            <div className="text-center text-gray-500">
              You haven’t earned any badges yet. Keep contributing!
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {badges.map((badge, idx) => (
                <div
                  key={idx}
                  className="bg-gradient-to-r from-white via-orange-100 to-green-100 p-5 rounded-lg shadow text-center"
                >
                  <div className="mb-3 flex justify-center">
                    {badgeIcons[badge.name] || (
                      <BadgeCheck className="w-8 h-8 text-gray-600" />
                    )}
                  </div>
                  <h3 className="font-semibold text-lg text-gray-800">
                    {badge.name}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1">
                    {badge.description}
                  </p>
                </div>
              ))}
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default BadgesPage;
